import { getTrackingService } from '@gig/magic-common';
import { BALANCE_UPDATED, BALANCE_CHANGED, USER_UPDATED, USER_FIRST_LOG_IN_UPDATED, TRACKING_LOGOUT, USER_JURISDICTION_QUERY } from '@gig/magic-messages';
import { __awaiter, __generator } from 'tslib';
import { magic } from '@gig/magic-sdk';
import { Currency } from '@gig/magic-sdk/dist/adapter/users/signup';

var TrackingService = /** @class */ (function () {
    function TrackingService(trackingService, options) {
        if (options === void 0) { options = {}; }
        this.trackingService = trackingService;
        this.options = options;
        if (this.options.trackUserChangesOnly) {
            this.trackUserChanges();
        }
        else {
            this.trackBalanceChanges();
            this.trackUserChanges();
            this.setJurisdiction();
        }
    }
    TrackingService.setupUserTracking = function () {
        return new TrackingService(getTrackingService(), {
            trackUserChangesOnly: true,
        });
    };
    TrackingService.prototype.trackBalanceChanges = function () {
        var _this = this;
        window.eventBus.subscribe(BALANCE_UPDATED, function (event) {
            var _a;
            var balance = (_a = event.payload) !== null && _a !== void 0 ? _a : null;
            _this.trackingService.setBalance(balance);
        });
        window.eventBus.subscribe(BALANCE_CHANGED, function (event) {
            var _a;
            var balance = (_a = event.payload) !== null && _a !== void 0 ? _a : null;
            if (balance) {
                _this.trackBalanceChange(balance);
            }
        });
    };
    TrackingService.prototype.trackUserChanges = function () {
        var _this = this;
        window.eventBus.subscribe(USER_UPDATED, function (e) {
            if (e.payload !== null) {
                _this.trackingService.setUser(e.payload);
                _this.trackingService.trackLogin();
            }
            else {
                _this.trackingService.setUserAccounts([]);
            }
        });
        window.eventBus.subscribe(USER_FIRST_LOG_IN_UPDATED, function (e) {
            if (!!e.payload) {
                _this.trackingService.trackFirstLogin();
            }
        });
        window.eventBus.subscribe(TRACKING_LOGOUT, function (e) {
            _this.trackingService.trackLogout(e.payload);
        });
    };
    TrackingService.prototype.trackBalanceChange = function (_a) {
        var balance = _a.balance;
        var user = magic.session.getUser();
        if (!user) {
            return;
        }
        if (balance === 0) {
            this.trackingService.trackBalanceZero();
        }
        else if (balance < this.getLowBalanceLimit(user)) {
            this.trackingService.trackBalanceNearZero();
        }
    };
    TrackingService.prototype.setJurisdiction = function () {
        return __awaiter(this, void 0, void 0, function () {
            var currentJurisdiction;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, window.queryBus.query(USER_JURISDICTION_QUERY)];
                    case 1:
                        currentJurisdiction = _a.sent();
                        this.trackingService.setJurisdiction(currentJurisdiction);
                        return [2 /*return*/];
                }
            });
        });
    };
    TrackingService.prototype.getLowBalanceLimit = function (user) {
        if ([Currency.SEK, Currency.NOK].includes(user.currency)) {
            return 50;
        }
        return 5;
    };
    return TrackingService;
}());

export { TrackingService };
